<template>
  <v-dialog v-model="dialog" persistent max-width="400px">
    <ValidationObserver ref="validateObserver" v-slot="{ invalid }">
      <v-card>
        <v-card-title class="text-center">
          <span>Desativar conta</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row class="text-center pb-3">
              <v-col>
                <v-icon size="64">mdi-alert-outline</v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <mb-input-password v-model="password"
                  name="password" label="Senha" rules="required|min:6" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="close">Fechar</v-btn>
          <v-btn color="primary" text @click="save" :loading="saveLoading">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import bus from '@/plugins/eventBus';
import MbInputPassword from '@/components/general/inputs/MbInputPassword';

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dialog: false,
    password: null,
    saveLoading: false,
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
  },
  created() {
    this.dialog = this.value;
  },
  methods: {
    close() {
      this.dialog = false;
      this.$emit('input', false);
    },
    async save() {
      const isValid = await this.$refs.validateObserver.validate();
      if (isValid) {
        const params = { patientId: this.user.id, password: this.password };
        this.$store
          .dispatch('patientUser/deactivate', params)
          .then(() => {
            bus.$emit('message', {
              message: 'Conta desativada com sucesso!',
              type: 'success',
            });

            this.saveBtnLoading = false;
            this.$emit('input', false);
            const self = this;

            // Logout
            setTimeout(() => {
              self.$store
                .dispatch('auth/logout')
                .then(() => self.$router.push('/login'));
            }, 2000);
          })
          .catch((err) => {
            bus.$emit('message', {
              message: err.response.data.message,
              type: 'error',
            });
          })
          .finally(() => {
            this.saveBtnLoading = false;
          });
      }
    },
  },
  watch: {
    value(vl) {
      this.dialog = vl;
    },
  },
  components: {
    ValidationObserver,
    MbInputPassword,
  },
};
</script>
